import React, {useEffect, useState} from "react";
import {useParams, useLocation} from 'react-router-dom';
import {PayUseDetailTypes} from "../../../types/transaction/transaction.types";
import {getMemberPayUseDetail} from "../../../api/transaction/payApi";
import {formatDateTime, setComma} from "../../../utils/format";
import {formatTimeText} from "../../../utils/date";

const UseDetailPage = () => {

    const {id} = useParams<{ id: string }>();
    const location = useLocation();
    const { useType } = location.state as { useType: string };
    const [useData, setUseData] = useState<PayUseDetailTypes>();
    const [loading, setLoading] = useState(true);


    const getUseData = async () => {
        if (!id) return;
        try {
            setLoading(true);
            const response = await getMemberPayUseDetail(id, useType);
            if (response.data.code === "00") {

                setUseData(response.data.data);
            }
        } catch (err) {
            console.error('사용 상세 에러:', err);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getUseData();
    }, [])

    return (
        <>
            {(!loading && useData) && (() => {
                const workType = useData.workType === "DAILY" ? "일급" : "시급";

                const adjust = useData.adjust;

                const isCancel = useData.useType === "USE_CANCEL";
                const isAdjustment = useData.useType === "ADJUSTMENT";
                // 급여조정(재정산): add=추가결제(useType USE) / deduct=환불(useType USE_CANCEL)
                const isAdjust = adjust === true;
                const isAdjustCharge = isAdjust && useData.useType === "USE";
                const statusText = isAdjust
                    ? (isAdjustCharge ? "급여조정(추가결제)" : "급여조정(환불)")
                    : isAdjustment ? "차감완료"
                    : useData.useType === "USE_CANCEL" ? "결제취소" : "결제완료";
                const statusClass = isAdjust ? "status finish" : isCancel ? "status cancel" : "status finish";

                const workTypeText = useData.workType === "HOURLY" ? "시간제(" + formatTimeText(useData.workStartTime) + "~" + formatTimeText(useData.workEndTime): "일급제";

                const paymentAmountText = setComma(useData.paymentAmount);
                const cancelAmount = setComma(useData.paymentAmount - useData.cancellationFee);
                const regDate = formatDateTime(useData.regDate);
                // 급여조정 표시용: 순 조정 급여(수수료 제외) / 실제 지갑 변동 라벨
                const adjustNetAmount = (useData.paymentAmount || 0) - (useData.paymentFee || 0);
                const adjustActualLabel = isAdjustCharge ? "추가결제 금액" : "환불 금액";
                // 매칭 결제건에서 공고 원래 금액과 실제 결제(조정) 금액이 다르면 원래 금액도 표시
                const netPay = (useData.paymentAmount || 0) - (useData.paymentFee || 0);
                const showOriginalAmount = !isCancel && !isAdjust
                    && (useData.originalAmount || 0) > 0
                    && (useData.originalAmount || 0) !== netPay;

                return (
                    <div>
                        <main className="container type_gray">
                            <section className="bg-white">
                                <div className="inner-box">
                                    <h3 className="dot-tit">기본 정보</h3>
                                    <ul className="detail-info">
                                        <li>
                                            <span className="tit">거래금액</span>
                                            <span className="txt">{paymentAmountText}원</span>
                                        </li>
                                        <li>
                                            <span className="tit">거래일시</span>
                                            <span className="txt">{regDate}</span>
                                        </li>
                                        <li>
                                            <span className="tit">서비스구분</span>
                                            <span className="txt">{useData.serviceType}</span>
                                        </li>
                                        <li>
                                            <span className="tit">거래상태</span>
                                            <span className={statusClass}>{statusText}</span>
                                        </li>
                                    </ul>
                                </div>
                            </section>

                            {!isAdjustment && (
                                <>
                                    <section className="bg-white">
                                        <div className="inner-box">
                                            <h3 className="dot-tit">공고 정보</h3>
                                            <ul className="detail-info">
                                                <li>
                                                    <span className="tit">공고번호</span>
                                                    <span className="txt">{useData.jobPostingCode}</span>
                                                </li>
                                                <li>
                                                    <span className="tit">어르신명</span>
                                                    <span className="txt">{useData.elderName}</span>
                                                </li>
                                                <li>
                                                    <span className="tit">시작일</span>
                                                    <span className="txt">{useData.careStartDate}</span>
                                                </li>
                                                <li>
                                                    <span className="tit">종료일</span>
                                                    <span className="txt">{useData.careEndDate}</span>
                                                </li>
                                                <li>
                                                    <span className="tit">서비스 유형</span>
                                                    <span className="txt">{workTypeText}</span>
                                                </li>
                                                <li>
                                                    <span className="tit">돌봄 급여</span>
                                                    <span className="txt">{workType} {setComma(useData.dailyPay)}원</span>
                                                </li>
                                                {showOriginalAmount && (
                                                    <li>
                                                        <span className="tit">공고 원래 금액</span>
                                                        <span className="txt">{setComma(useData.originalAmount || 0)}원</span>
                                                    </li>
                                                )}
                                                <li>
                                                    <span className="tit">{showOriginalAmount ? "총 급여 (조정)" : "총 급여"}</span>
                                                    <span className="txt">{setComma(netPay)}원</span>
                                                </li>
                                                <li>
                                                    <span className="tit">공고 상태</span>
                                                    <span className="txt">{useData.jobPostingStatus}</span>
                                                </li>
                                                {isCancel && !isAdjust && (
                                                    <li>
                                                        <span className="tit">취소자</span>
                                                        <span className="txt">{useData.cancelSubject}</span>
                                                    </li>
                                                )}
                                            </ul>
                                        </div>
                                    </section>
                                    <section className="bg-white">
                                        <div className="inner-box">
                                            <h3 className="dot-tit">코디 정보</h3>
                                            <ul className="detail-info">
                                                <li>
                                                    <span className="tit">코디번호</span>
                                                    <span className="txt">{useData.coordinatorCode}</span>
                                                </li>
                                                <li>
                                                    <span className="tit">코디명</span>
                                                    <span className="txt">{useData.coordinatorName}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </section>
                                </>
                            )}

                            <section className="bg-white">
                                <div className="inner-box">
                                    <h3 className="dot-tit">{isAdjust ? "조정 정보" : "결제 정보"}</h3>
                                    <ul className="detail-info">
                                        {isAdjust ? (
                                            <>
                                                <li>
                                                    <span className="tit">조정일시</span>
                                                    <span className="txt">{regDate}</span>
                                                </li>
                                                <li>
                                                    <span className="tit">결제수단</span>
                                                    <span className="txt">{useData.paymentMethod}</span>
                                                </li>
                                                <li>
                                                    <span className="tit">조정금액</span>
                                                    <span className="txt">{setComma(adjustNetAmount)}원</span>
                                                </li>
                                                <li>
                                                    <span className="tit">수수료</span>
                                                    <span className="txt">{setComma(useData.paymentFee || 0)}원</span>
                                                </li>
                                                <li>
                                                    <span className="tit">{adjustActualLabel}</span>
                                                    <span className="txt">{paymentAmountText}원</span>
                                                </li>
                                            </>
                                        ) : (
                                            <>
                                                <li>
                                                    <span className="tit">결제일시</span>
                                                    <span className="txt">{isCancel ? formatDateTime(useData.originPaymentDate) : regDate}</span>
                                                </li>
                                                {isCancel && (
                                                    <li>
                                                        <span className="tit">거래번호</span>
                                                        <span className="txt">{useData.originUseCode}</span>
                                                    </li>
                                                )}
                                                <li>
                                                    <span className="tit">결제수단</span>
                                                    <span className="txt">{isCancel ? useData.originPaymentMethod : useData.paymentMethod}</span>
                                                </li>
                                                {!isCancel && !isAdjustment && (
                                                    <li>
                                                        <span className="tit">결제수수료</span>
                                                        <span className="txt">{setComma(useData.paymentFee || 0)}원</span>
                                                    </li>
                                                )}
                                                <li>
                                                    <span className="tit">결제금액</span>
                                                    <span className="txt">{isCancel ? setComma(useData.originPaymentAmount) : paymentAmountText}원</span>
                                                </li>
                                            </>
                                        )}
                                    </ul>
                                </div>
                            </section>

                            {isCancel && !isAdjust && (
                                <section className="bg-white">
                                    <div className="inner-box">
                                        <h3 className="dot-tit">결제취소 정보</h3>
                                        <ul className="detail-info">
                                            <li>
                                                <span className="tit">결제취소일시</span>
                                                <span className="txt">{formatDateTime(useData.cancelDate)}</span>
                                            </li>
                                            <li>
                                                <span className="tit">결제취소수단</span>
                                                <span className="txt">{useData.paymentMethod}</span>
                                            </li>
                                            <li>
                                                <span className="tit">결제취소금액</span>
                                                <span className="txt">{cancelAmount}원</span>
                                            </li>
                                            <li>
                                                <span className="tit">취소위약금</span>
                                                <span className="txt">{setComma(useData.cancellationFee)}원</span>
                                            </li>
                                        </ul>
                                    </div>
                                </section>
                            )}
                        </main>
                    </div>
                );
            })()}
        </>

    );
};

export default UseDetailPage;

